/* eslint-disable no-unused-vars */
// This is used when reading true/false out of data props.
export enum BooleanState {
  TRUE = 'true',
  FALSE = 'false'
}
